import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=1e85d394&scoped=true&"
import script from "./Pay.vue?vue&type=script&lang=js&"
export * from "./Pay.vue?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Pay.vue?vue&type=style&index=1&id=1e85d394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85d394",
  null
  
)

export default component.exports